import React, { useEffect, useState } from 'react'
import Notification from '../Utils/Notification'
import { SUCCESS } from '../../utils/constants'
import { withAuth } from '../AuthContext'
import { withRouter, useLocation } from 'react-router-dom'
import Error from '../Utils/Error'
import { shouldTranslateTo } from '../../utils/utils'
import styled from 'styled-components'
import Cookies from 'universal-cookie'

import {
  Title,
  CustomSubtitle,
  ActionButtons,
  LoadingButton,
  FormInput,
  FormSelect,
  TextArea,
  CheckboxDiv,
  Checkbox,
} from '../Utils/CustomClasses'

const ContainerBox = styled.div`
  padding: 30px 36px 55px 36px;
  background-color: #ffffff;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const FormContent = styled.div`
  margin-top: 50px;
  display: flex;

  button {
    width: 30vw;
    min-width: 250px;

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`

const ErrorWrapper = styled.div`
  margin: 20px 0 0 0;
  padding: 0;

  > div {
    padding: 0;
    > label {
      margin: 0 !important;
    }
  }
`

const EditProfileStage2App = ({ data, onUpdate }) => {
  const [languagesOptions, setLanguagesOptions] = useState([])
  const [defaultLanguages, setDefaultLanguages] = useState([])
  const [languages, setLanguages] = useState([])
  const [languagesError, setLanguagesError] = useState(false)
  const [introduction, setIntroduction] = useState('')
  const [introductionError, setIntroductionError] = useState(false)
  const [interest, setInterest] = useState('')
  const [interestError, setInterestError] = useState(false)
  const [philosophy, setPhilosophy] = useState('')
  const [philosophyError, setPhilosophyError] = useState(false)
  const [favoBook, setFavoBook] = useState('')
  const [favoFilm, setFavoFilm] = useState('')
  const [favoActor, setFavoActor] = useState('')
  const [favoMusician, setFavoMusician] = useState('')
  const [favoPlace, setFavoPlace] = useState('')
  const [favoFood, setFavoFood] = useState('')
  const [favoExercise, setFavoExercise] = useState('')
  const [favoHero, setFavoHero] = useState('')
  const [favoVisitedPlace, setFavoVisitedPlace] = useState('')
  const [genderPreference, setGenderPreference] = useState('')
  const [genderPreferenceError, setGenderPreferenceError] = useState(false)
  const [loading, setLoading] = useState('')
  const [error, setError] = useState('')
  const [pageText, setPageText] = useState([])
  const [st, setSt] = useState('')
  const location = useLocation()
  const queryParameters = new URLSearchParams(location.search)
  const cookies = new Cookies()

  useEffect(() => {
    axios
      .get('/api/languages-all')
      .then((res) => {
        const languagesOptionsData = res.data.map(function (language) {
          return { label: language.name, value: language.id }
        })
        setLanguagesOptions(languagesOptionsData)
      })
      .catch((e) => {
        console.log(e)
      })

    setSt(queryParameters.get('st'))
    cookies.set('stss', 'y', { path: '/' })

    const user = data.auth.user
    const userLanguages = user.languages
    setLanguages(
      userLanguages &&
        userLanguages.map(function (language) {
          return language.id
        })
    )
    setDefaultLanguages(
      userLanguages &&
        userLanguages.map(function (language) {
          return { label: language.name, value: language.id }
        })
    )
    setIntroduction(user.introduction)
    setInterest(user.interest)
    setFavoBook(user.favoBook)
    setFavoFilm(user.favoFilm)
    setFavoActor(user.favoActor)
    setFavoMusician(user.favoMusician)
    setFavoPlace(user.favoPlace)
    setFavoFood(user.favoFood)
    setFavoExercise(user.favoExercise)
    setFavoHero(user.favoHero)
    setFavoVisitedPlace(user.favoVisitedPlace)
    setPhilosophy(user.philosophy)
    setGenderPreference(user.genderPreference)

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('profile-information', language)
  }, [])

  const handleInputChange = (e) => {
    const target = e.target
    const name = target.name
    setError('')
    setIntroductionError(false)
    setInterestError(false)
    setGenderPreferenceError(false)
    setLanguagesError(false)
    switch (name) {
      case 'introduction':
        setIntroduction(e.target.value)
        break
      case 'interest':
        setInterest(e.target.value)
        break
      case 'philosophy':
        setPhilosophy(e.target.value)
        break
      case 'favoBook':
        setFavoBook(e.target.value)
        break
      case 'favoFilm':
        setFavoFilm(e.target.value)
        break
      case 'favoActor':
        setFavoActor(e.target.value)
        break
      case 'favoMusician':
        setFavoMusician(e.target.value)
        break
      case 'favoPlace':
        setFavoPlace(e.target.value)
        break
      case 'favoFood':
        setFavoFood(e.target.value)
        break
      case 'favoExercise':
        setFavoExercise(e.target.value)
        break
      case 'favoHero':
        setFavoHero(e.target.value)
        break
      case 'favoVisitedPlace':
        setFavoVisitedPlace(e.target.value)
        break
      default:
        break
    }
  }

  const handleGenderPreferenceChange = (e) => {
    setError('')
    setIntroductionError(false)
    setGenderPreferenceError(false)
    setLanguagesError(false)
    setGenderPreference(e.target.value)
  }

  const handleDivGenderPreferenceChange = (value) => {
    setError('')
    setIntroductionError(false)
    setGenderPreferenceError(false)
    setLanguagesError(false)
    setGenderPreference(value)
  }

  const handleLanguageChange = (option) => {
    setError('')
    setIntroductionError(false)
    setGenderPreferenceError(false)
    setLanguagesError(false)
    const languagesData = option.map(function (option) {
      return option.value
    })
    setLanguages(languagesData)
    setDefaultLanguages(languagesData)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!introduction) {
      setIntroductionError(true)
      setError('Please complete the introduce yourself field before proceeding')
      return
    } else if (!interest) {
      setInterstError(true)
      setError('Please complete the interests field before proceeding')
      return
    } else if (!philosophy) {
      setPhilosophyError(true)
      setError('Please add your philosophy of life before proceeding')
      return
    } else if (!genderPreference) {
      setGenderPreferenceError(true)
      setError('Please state your contact preferences before proceeding')
      return
    } else if (languages.length < 1) {
      setLanguagesError(true)
      setError('Please state which languages you can speak before proceeding')
      return
    }

    setLoading(true)

    const userData = {
      introduction: introduction,
      interest: interest,
      philosophy: philosophy,
      favoBook: favoBook,
      favoFilm: favoFilm,
      favoActor: favoActor,
      favoMusician: favoMusician,
      favoPlace: favoPlace,
      favoFood: favoFood,
      favoExercise: favoExercise,
      favoHero: favoHero,
      favoVisitedPlace: favoVisitedPlace,
      introductionStatus: 'completed',
      interestStatus: 'completed',
      favoStatus: 'completed',
    }

    data.auth
      .updateUser(userData)
      .then(() => {
        Notification({
          type: SUCCESS,
          message: 'Profile edited successfully',
        })

        data.auth.refreshUser()

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        setTimeout(function () {
          onUpdate()
        }, 1000)

        setLoading(false)
      })
      .catch((e) => {
        Notification({
          data: e,
        })
        setLoading(false)
      })
  }

  if (pageText.length === 0 || languagesOptions.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }

  const favs = [
    {
      name: 'favoBook',
      label: pageText[23],
      placeholder: pageText[34],
      value: favoBook,
    },
    {
      name: 'favoFilm',
      label: pageText[24],
      placeholder: pageText[35],
      value: favoFilm,
    },
    {
      name: 'favoActor',
      label: pageText[25],
      placeholder: pageText[36],
      value: favoActor,
    },
    {
      name: 'favoMusician',
      label: pageText[26],
      placeholder: pageText[37],
      value: favoMusician,
    },
    {
      name: 'favoFood',
      label: pageText[28],
      placeholder: pageText[39],
      value: favoFood,
    },
    {
      name: 'favoExercise',
      label: pageText[29],
      placeholder: pageText[40],
      value: favoExercise,
    },
    {
      name: 'favoHero',
      label: pageText[30],
      placeholder: pageText[41],
      value: favoHero,
    },
  ]

  const travelFavs = [
    {
      name: 'favoPlace',
      label: pageText[27],
      placeholder: pageText[38],
      value: favoPlace,
    },
    {
      name: 'favoVisitedPlace',
      label: pageText[31],
      placeholder: pageText[42],
      value: favoVisitedPlace,
    },
  ]

  const favourites = favs.map((f) => (
    <FavInput
      key={f.name}
      name={f.name}
      label={f.label}
      value={f.value}
      onChange={(e) => handleInputChange(e)}
      placeholder={f.placeholder}
    />
  ))

  const travelFavourites = travelFavs.map((f) => (
    <FavInput
      key={f.name}
      name={f.name}
      label={f.label}
      value={f.value}
      onChange={(e) => handleInputChange(e)}
      placeholder={f.placeholder}
    />
  ))

  return (
    <ContainerBox>
      <Title
        size="29px"
        sizemd="29px"
        sizesm="24px"
        margin="0"
        dangerouslySetInnerHTML={{
          __html: `${pageText[1]}`,
        }}
      ></Title>

      <form
        method="POST"
        action="/"
        name="myForm"
        aria-label="Add Profile"
        onSubmit={(e) => handleSubmit(e)}
      >
        <input
          type="hidden"
          name="csrf-token"
          value={window.Laravel.csrfToken}
        />
        {data.auth.user.status === 'partiallycompleted' && (
          <CustomSubtitle
            size="18px"
            margin="0 0 46px 0px"
            weight="400"
            dangerouslySetInnerHTML={{
              __html: `${pageText[44]}`,
            }}
          />
        )}

        {/* Philosophy of Life */}
        <CustomSubtitle
          bold
          size="22px"
          margin="25px 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[13]}`,
          }}
        />
        <CustomSubtitle
          size="18px"
          margin="0 0 16px 0px"
          weight="400"
          dangerouslySetInnerHTML={{
            __html: `${pageText[14]}`,
          }}
        />
        <TextArea
          id="philosophy"
          name="philosophy"
          rows="5"
          required
          placeholder={pageText[43]}
          value={philosophy}
          className={!philosophy && 'empty-box'}
          onChange={(e) => handleInputChange(e)}
        />
        {/* MY TRAVELS */}
        <CustomSubtitle
          bold
          size="22px"
          margin="40px 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[52]}`,
          }}
        />
        <CustomSubtitle
          size="18px"
          margin="0 0 30px 0px"
          weight="400"
          dangerouslySetInnerHTML={{
            __html: `${pageText[53]}`,
          }}
        />
        {travelFavourites}

        {/* FAVORITE THINGS */}
        <CustomSubtitle
          bold
          size="22px"
          margin="20px 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[11]}`,
          }}
        />
        <CustomSubtitle
          size="18px"
          margin="0 0 30px 0px"
          weight="400"
          dangerouslySetInnerHTML={{
            __html: `${pageText[12]}`,
          }}
        />
        {favourites}

        {/* INTRODUCE YORSELF */}
        <CustomSubtitle
          bold
          size="22px"
          margin="20px 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[2]}`,
          }}
        />
        <CustomSubtitle
          size="18px"
          margin="0 0 16px 0px"
          weight="400"
          dangerouslySetInnerHTML={{
            __html: `${pageText[3]}`,
          }}
        />
        <TextArea
          id="introduction"
          name="introduction"
          className={introductionError && 'error-border'}
          rows="5"
          required
          placeholder={pageText[32]}
          value={introduction}
          onChange={(e) => handleInputChange(e)}
        />
        {/* Interests */}
        <CustomSubtitle
          bold
          size="22px"
          margin="30px 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[4]}`,
          }}
        />
        <CustomSubtitle
          size="18px"
          margin="0 0 16px 0px"
          weight="400"
          dangerouslySetInnerHTML={{
            __html: `${pageText[5]}`,
          }}
        />
        <TextArea
          id="interest"
          name="interest"
          rows="5"
          placeholder={pageText[33]}
          required
          value={interest}
          onChange={(e) => handleInputChange(e)}
        />

        {/* I WANT TO BE CONTACTED BY */}
        <CustomSubtitle
          bold
          size="22px"
          margin="40px 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[9]}`,
          }}
        />
        <CustomSubtitle
          size="18px"
          margin="0 0 16px 0px"
          weight="400"
          dangerouslySetInnerHTML={{
            __html: `${pageText[10]}`,
          }}
        />

        <CheckboxDiv
          className={
            genderPreference === 'any'
              ? 'checked'
              : genderPreferenceError
                ? 'error-border'
                : ''
          }
          onClick={() => handleDivGenderPreferenceChange('any')}
        >
          <Checkbox
            type="radio"
            name="genderPreference"
            id="genderPreference-any"
            className={genderPreference === 'any' && 'checked'}
            value={'any'}
            checked={genderPreference === 'any'}
            onChange={(e) => handleGenderPreferenceChange(e)}
          />
          <CustomSubtitle
            bold={genderPreference === 'any'}
            size="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[20]}`,
            }}
          />
        </CheckboxDiv>

        <CheckboxDiv
          className={
            genderPreference === 'womenonly'
              ? 'checked'
              : genderPreferenceError
                ? 'error-border'
                : ''
          }
          onClick={() => handleDivGenderPreferenceChange('womenonly')}
        >
          <Checkbox
            type="radio"
            name="genderPreference"
            id="genderPreference-womenonly"
            className={genderPreference === 'womenonly' && 'checked'}
            value={'womenonly'}
            checked={genderPreference === 'womenonly'}
            onChange={(e) => handleGenderPreferenceChange(e)}
          />
          <CustomSubtitle
            bold={genderPreference === 'womenonly'}
            size="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[21]}`,
            }}
          />
        </CheckboxDiv>

        <CheckboxDiv
          className={
            genderPreference === 'menonly'
              ? 'checked'
              : genderPreferenceError
                ? 'error-border'
                : ''
          }
          onClick={() => handleDivGenderPreferenceChange('menonly')}
        >
          <Checkbox
            type="radio"
            name="genderPreference"
            id="genderPreference-menonly"
            className={genderPreference === 'menonly' && 'checked'}
            value={'menonly'}
            checked={genderPreference === 'menonly'}
            onChange={(e) => handleGenderPreferenceChange(e)}
          />
          <CustomSubtitle
            bold={genderPreference === 'menonly'}
            size="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[22]}`,
            }}
          />
        </CheckboxDiv>

        {/* LANGUAGES */}
        <CustomSubtitle
          bold
          size="22px"
          margin="35px 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[15]}`,
          }}
        />
        <CustomSubtitle
          bold
          size="18px"
          margin="0 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[16]}`,
          }}
        />

        <FormSelect
          width="100%"
          id="languages"
          name="languages"
          className={languagesError && 'error-border'}
          isDisabled={false}
          isLoading={false}
          isClearable={false}
          isRtl={false}
          isSearchable={true}
          options={languagesOptions}
          required
          onChange={handleLanguageChange}
          isMulti
          defaultValue={defaultLanguages}
        />

        <FormContent>
          {loading ? (
            <LoadingButton padding="9px 10px">{pageText[17]}</LoadingButton>
          ) : (
            <ActionButtons type="submit" padding="9px 10px">
              {pageText[17]}
            </ActionButtons>
          )}
        </FormContent>

        <ErrorWrapper>{error && <Error error={error} />} </ErrorWrapper>
      </form>
    </ContainerBox>
  )
}

const FavInput = (props) => {
  return (
    <div>
      <CustomSubtitle
        mediumBold
        size="18px"
        sizesm="16px"
        margin="0 0 11px 0px"
        dangerouslySetInnerHTML={{
          __html: `${props.label}`,
        }}
      />
      <FormInput
        id={props.name}
        type="text"
        row="2"
        name={props.name}
        placeholder={props.placeholder}
        onChange={props.onChange}
        defaultValue={props.value}
        className={!props.value && 'empty-box'}
        autoComplete="off"
      />
    </div>
  )
}

export default withRouter(withAuth(EditProfileStage2App))
